import { createSelector } from 'reselect';
import { AppState } from '@Redux/store';
import { IArsenalArmyUnitExportProps } from '@Builder/myArsenal/army/make/share/arsenal-army-unit-export.component';
import { ArsenalUnit, PaintStep } from '@Models';
import { getAllEnumValues } from 'enum-for';
import { ArsenalUnitExportView } from '@Selectors/arsenal/share/view/ArsenalUnitExportView';

const getCurrentUnit = (
  _: AppState,
  ownProps: IArsenalArmyUnitExportProps,
): ArsenalUnit => ownProps.unit;

export const shareArsenalUnitSelector = createSelector(
  [getCurrentUnit],
  (unit): ArsenalUnitExportView => {
    if (!unit)
      return {
        name: '',
        steps: [],
      } satisfies ArsenalUnitExportView as ArsenalUnitExportView;

    const paintSteps = getAllEnumValues(PaintStep).map((step) => {
      const size = unit.steps.find((s) => s.step === step)?.size ?? 0;
      if (size === 0) return '';

      return `${PaintStep[step]}: ${size}`;
    });

    return {
      name: unit.name,
      steps: paintSteps,
    } satisfies ArsenalUnitExportView as ArsenalUnitExportView;
  },
);
